import { makeStyles, Theme } from '@material-ui/core';

export const useSetTxFeeStyles = makeStyles<Theme>((theme) => ({
  wrapper: {
    width: '100%',
    display: 'grid',
    margin: '32px 0 0',
    gap: 24,
  },
  recomendedWrapper: {
    display: 'grid',
    gap: 16,
  },
  feeItem: {
    borderRadius: '8px',
    border: '1px solid #292A2F',
    padding: '12px 16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
  },
  feeItemActive: {
    borderRadius: '8px',
    border: '1px solid #292A2F',
    background: '#292A2F',
  },
  feeContent: {
    display: 'grid',
    gap: 4,
  },
  feeTitle: {
    color: '#FAFAFA',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '22px',
  },
  feeTime: {
    color: '#ABABAB',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '22px',
  },
  feeAmount: {
    color: '#ABABAB',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '22px',
  },
  customWrapper: {
    display: 'grid',
    gap: 24,
  },
  hintWrapper: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    borderRadius: '8px',
    background: '#34353B',
    padding: 8,
    justifySelf: 'start',
  },
  hintContent: {},
  infoWrapper: {
    display: 'grid',
    gap: 4,
  },
  infoRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  infoRowTitle: {
    color: '#FAFAFA',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
  },
  infoRowContent: {
    color: '#ABABAB',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
  },
  choseFeeNav: {
    display: 'flex',
    gap: 16,
    borderBottom: '1px solid #323235',
    paddingBottom: 16,
  },
  navItem: {
    color: '#8A8A8A',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    cursor: 'pointer',
  },
  navItemAvive: {
    cursor: 'unset',
    color: '#FAFAFA',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    position: 'relative',

    '&:before': {
      content: '""',
      position: 'absolute',
      left: 0,
      bottom: -17,
      width: '100%',
      height: 3,
      background: '#FAFAFA',
    },
  },
  buttonsWrapper: {
    display: 'flex',
    gap: 16,
  },
  loader: {
    margin: 'auto',
  },
  error: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#e44e45',
    marginTop: '4px',
  },
}));
